var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoices"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('InvoicesTable',{attrs:{"isReadOnly":_vm.isReadOnly},on:{"create-invoice":_vm.onCreateInvoice,"edit-invoice":_vm.onEditInvoice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }